/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  type DataTag,
  type InfiniteData,
  type MutationFunction,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseInfiniteQueryOptions,
  type UseInfiniteQueryReturnType,
  type UseMutationOptions,
  type UseMutationReturnType,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { computed, toValue, unref, type MaybeRefOrGetter } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useMutationOptions } from ".././mutationOptions.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type {
  BankingDetailsRequest,
  BankingDetailsResponse,
  CreateDirectDebitRequest,
  Error,
  GetCurrentDirectDebitResponse,
  GetLatestDirectDebitResponse,
  GetPaymentByIdentifierParams,
  GetTransactionsResponse,
  GetTransactionsV2Params,
  GetVariablePaymentDetailsResponse,
  MakePaymentRequest,
  MakePaymentResponse,
  MakePaymentSessionResponse,
  Payment,
  PaymentScheduleDetails,
} from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get transactions for account
 */
export const getTransactionsV2 = (
  accountId: MaybeRefOrGetter<number>,
  params: MaybeRefOrGetter<GetTransactionsV2Params>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  params = toValue(params)

  return customInstance<GetTransactionsResponse>(
    {
      url: `/api/v2/accounts/${accountId}/transactions`,
      method: "GET",
      params,
      signal,
    },
    options,
  )
}

export const getGetTransactionsV2InfiniteQueryKey = (
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetTransactionsV2Params>,
) => {
  return [
    "infinite",
    "api",
    "v2",
    "accounts",
    accountId,
    "transactions",
    ...(params ? [params] : []),
  ] as const
}

export const getGetTransactionsV2QueryKey = (
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetTransactionsV2Params>,
) => {
  return [
    "api",
    "v2",
    "accounts",
    accountId,
    "transactions",
    ...(params ? [params] : []),
  ] as const
}

export const useGetTransactionsV2InfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getTransactionsV2>>,
    GetTransactionsV2Params["offset"]
  >,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  params: MaybeRefOrGetter<GetTransactionsV2Params>,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTransactionsV2>>,
        TError,
        TData,
        Awaited<ReturnType<typeof getTransactionsV2>>,
        QueryKey,
        GetTransactionsV2Params["offset"]
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetTransactionsV2InfiniteQueryKey(accountId, params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTransactionsV2>>,
    QueryKey,
    GetTransactionsV2Params["offset"]
  > = ({ signal, pageParam }) =>
    getTransactionsV2(
      accountId,
      { ...toValue(params), offset: pageParam ?? toValue(params)?.["offset"] },
      requestOptions,
      signal,
    )

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId, params },
  )

  return customOptions as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTransactionsV2>>,
    TError,
    TData,
    Awaited<ReturnType<typeof getTransactionsV2>>,
    QueryKey,
    GetTransactionsV2Params["offset"]
  >
}

export type GetTransactionsV2InfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTransactionsV2>>
>
export type GetTransactionsV2InfiniteQueryError = ErrorType<Error>

/**
 * @summary Get transactions for account
 */

export function useGetTransactionsV2Infinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getTransactionsV2>>,
    GetTransactionsV2Params["offset"]
  >,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  params: MaybeRefOrGetter<GetTransactionsV2Params>,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTransactionsV2>>,
        TError,
        TData,
        Awaited<ReturnType<typeof getTransactionsV2>>,
        QueryKey,
        GetTransactionsV2Params["offset"]
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseInfiniteQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetTransactionsV2InfiniteQueryOptions(
    accountId,
    params,
    options,
  )

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

export const useGetTransactionsV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getTransactionsV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  params: MaybeRefOrGetter<GetTransactionsV2Params>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransactionsV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetTransactionsV2QueryKey(accountId, params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTransactionsV2>>
  > = ({ signal }) =>
    getTransactionsV2(accountId, params, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId, params },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getTransactionsV2>>,
    TError,
    TData
  >
}

export type GetTransactionsV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getTransactionsV2>>
>
export type GetTransactionsV2QueryError = ErrorType<Error>

/**
 * @summary Get transactions for account
 */

export function useGetTransactionsV2<
  TData = Awaited<ReturnType<typeof getTransactionsV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  params: MaybeRefOrGetter<GetTransactionsV2Params>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransactionsV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetTransactionsV2QueryOptions(
    accountId,
    params,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Create a Direct Debit mandate for the account. Create-only: an existing mandate is superseded by Junifer, not cancelled here.
 */
export const createDirectDebit = (
  accountId: MaybeRefOrGetter<number>,
  createDirectDebitRequest: MaybeRefOrGetter<CreateDirectDebitRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  createDirectDebitRequest = toValue(createDirectDebitRequest)

  return customInstance<void>(
    {
      url: `/api/v1/accounts/${accountId}/directDebits`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createDirectDebitRequest,
      signal,
    },
    options,
  )
}

export const useCreateDirectDebitMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDirectDebit>>,
    TError,
    { accountId: number; data: CreateDirectDebitRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDirectDebit>>,
  TError,
  { accountId: number; data: CreateDirectDebitRequest },
  TContext
> => {
  const mutationKey = ["createDirectDebit"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDirectDebit>>,
    { accountId: number; data: CreateDirectDebitRequest }
  > = (props) => {
    const { accountId, data } = props ?? {}

    return createDirectDebit(accountId, data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type CreateDirectDebitMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDirectDebit>>
>
export type CreateDirectDebitMutationBody = CreateDirectDebitRequest
export type CreateDirectDebitMutationError = ErrorType<Error>

/**
 * @summary Create a Direct Debit mandate for the account. Create-only: an existing mandate is superseded by Junifer, not cancelled here.
 */
export const useCreateDirectDebit = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDirectDebit>>,
      TError,
      { accountId: number; data: CreateDirectDebitRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof createDirectDebit>>,
  TError,
  { accountId: number; data: CreateDirectDebitRequest },
  TContext
> => {
  return useMutation(useCreateDirectDebitMutationOptions(options), queryClient)
}
/**
 * @summary The account's most recent Direct Debit: when it was cancelled. cancelledOn is absent unless the account's Direct Debit state is cancelled.
 */
export const getLatestDirectDebit = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<GetLatestDirectDebitResponse>(
    {
      url: `/api/v1/accounts/${accountId}/directDebits/latest`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getGetLatestDirectDebitQueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return ["api", "v1", "accounts", accountId, "directDebits", "latest"] as const
}

export const useGetLatestDirectDebitQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatestDirectDebit>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLatestDirectDebit>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetLatestDirectDebitQueryKey(accountId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLatestDirectDebit>>
  > = ({ signal }) => getLatestDirectDebit(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getLatestDirectDebit>>,
    TError,
    TData
  >
}

export type GetLatestDirectDebitQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLatestDirectDebit>>
>
export type GetLatestDirectDebitQueryError = ErrorType<Error>

/**
 * @summary The account's most recent Direct Debit: when it was cancelled. cancelledOn is absent unless the account's Direct Debit state is cancelled.
 */

export function useGetLatestDirectDebit<
  TData = Awaited<ReturnType<typeof getLatestDirectDebit>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLatestDirectDebit>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetLatestDirectDebitQueryOptions(accountId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary The Direct Debit on file for the account: its holder name, and its account number and sort code masked apart from their last three and first two digits.
 */
export const getCurrentDirectDebit = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<GetCurrentDirectDebitResponse>(
    {
      url: `/api/v1/accounts/${accountId}/directDebits/current`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getGetCurrentDirectDebitQueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return [
    "api",
    "v1",
    "accounts",
    accountId,
    "directDebits",
    "current",
  ] as const
}

export const useGetCurrentDirectDebitQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentDirectDebit>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentDirectDebit>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetCurrentDirectDebitQueryKey(accountId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCurrentDirectDebit>>
  > = ({ signal }) => getCurrentDirectDebit(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentDirectDebit>>,
    TError,
    TData
  >
}

export type GetCurrentDirectDebitQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentDirectDebit>>
>
export type GetCurrentDirectDebitQueryError = ErrorType<Error>

/**
 * @summary The Direct Debit on file for the account: its holder name, and its account number and sort code masked apart from their last three and first two digits.
 */

export function useGetCurrentDirectDebit<
  TData = Awaited<ReturnType<typeof getCurrentDirectDebit>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentDirectDebit>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetCurrentDirectDebitQueryOptions(accountId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Download the PDF file for direct debit mandate of the account
 */
export const downloadDirectDebitMandatePdfV2 = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<Blob>(
    {
      url: `/api/v2/accounts/${accountId}/directDebitMandate`,
      method: "GET",
      responseType: "blob",
      signal,
    },
    options,
  )
}

export const getDownloadDirectDebitMandatePdfV2QueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return ["api", "v2", "accounts", accountId, "directDebitMandate"] as const
}

export const useDownloadDirectDebitMandatePdfV2QueryOptions = <
  TData = Awaited<ReturnType<typeof downloadDirectDebitMandatePdfV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadDirectDebitMandatePdfV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getDownloadDirectDebitMandatePdfV2QueryKey(accountId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadDirectDebitMandatePdfV2>>
  > = ({ signal }) =>
    downloadDirectDebitMandatePdfV2(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof downloadDirectDebitMandatePdfV2>>,
    TError,
    TData
  >
}

export type DownloadDirectDebitMandatePdfV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadDirectDebitMandatePdfV2>>
>
export type DownloadDirectDebitMandatePdfV2QueryError = ErrorType<Error>

/**
 * @summary Download the PDF file for direct debit mandate of the account
 */

export function useDownloadDirectDebitMandatePdfV2<
  TData = Awaited<ReturnType<typeof downloadDirectDebitMandatePdfV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadDirectDebitMandatePdfV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useDownloadDirectDebitMandatePdfV2QueryOptions(
    accountId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Get current and future paymentSchedules for an account.
 */
export const getPaymentScheduleDetailsV2 = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<PaymentScheduleDetails>(
    {
      url: `/api/v2/accounts/${accountId}/paymentScheduleDetails`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getGetPaymentScheduleDetailsV2QueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return ["api", "v2", "accounts", accountId, "paymentScheduleDetails"] as const
}

export const useGetPaymentScheduleDetailsV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentScheduleDetailsV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentScheduleDetailsV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetPaymentScheduleDetailsV2QueryKey(accountId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPaymentScheduleDetailsV2>>
  > = ({ signal }) =>
    getPaymentScheduleDetailsV2(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentScheduleDetailsV2>>,
    TError,
    TData
  >
}

export type GetPaymentScheduleDetailsV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentScheduleDetailsV2>>
>
export type GetPaymentScheduleDetailsV2QueryError = ErrorType<Error>

/**
 * @summary Get current and future paymentSchedules for an account.
 */

export function useGetPaymentScheduleDetailsV2<
  TData = Awaited<ReturnType<typeof getPaymentScheduleDetailsV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentScheduleDetailsV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetPaymentScheduleDetailsV2QueryOptions(
    accountId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Retrieve payment information related to variable customers
 */
export const getVariablePaymentDetailsV2 = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<GetVariablePaymentDetailsResponse>(
    {
      url: `/api/v2/accounts/${accountId}/variable-payment-details`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getGetVariablePaymentDetailsV2QueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return [
    "api",
    "v2",
    "accounts",
    accountId,
    "variable-payment-details",
  ] as const
}

export const useGetVariablePaymentDetailsV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getVariablePaymentDetailsV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVariablePaymentDetailsV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetVariablePaymentDetailsV2QueryKey(accountId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVariablePaymentDetailsV2>>
  > = ({ signal }) =>
    getVariablePaymentDetailsV2(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getVariablePaymentDetailsV2>>,
    TError,
    TData
  >
}

export type GetVariablePaymentDetailsV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getVariablePaymentDetailsV2>>
>
export type GetVariablePaymentDetailsV2QueryError = ErrorType<Error>

/**
 * @summary Retrieve payment information related to variable customers
 */

export function useGetVariablePaymentDetailsV2<
  TData = Awaited<ReturnType<typeof getVariablePaymentDetailsV2>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVariablePaymentDetailsV2>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetVariablePaymentDetailsV2QueryOptions(
    accountId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * Banking Details Validation
 * @summary Validate banking details
 */
export const validateBankingDetails = (
  bankingDetailsRequest: MaybeRefOrGetter<BankingDetailsRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  bankingDetailsRequest = toValue(bankingDetailsRequest)

  return customInstance<BankingDetailsResponse>(
    {
      url: `/api/v1/banking-details/validate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankingDetailsRequest,
      signal,
    },
    options,
  )
}

export const useValidateBankingDetailsMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateBankingDetails>>,
    TError,
    { data: BankingDetailsRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateBankingDetails>>,
  TError,
  { data: BankingDetailsRequest },
  TContext
> => {
  const mutationKey = ["validateBankingDetails"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateBankingDetails>>,
    { data: BankingDetailsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return validateBankingDetails(data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type ValidateBankingDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateBankingDetails>>
>
export type ValidateBankingDetailsMutationBody = BankingDetailsRequest
export type ValidateBankingDetailsMutationError = ErrorType<Error>

/**
 * @summary Validate banking details
 */
export const useValidateBankingDetails = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validateBankingDetails>>,
      TError,
      { data: BankingDetailsRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof validateBankingDetails>>,
  TError,
  { data: BankingDetailsRequest },
  TContext
> => {
  return useMutation(
    useValidateBankingDetailsMutationOptions(options),
    queryClient,
  )
}
/**
 * @summary Get a payment by a unique identifier
 */
export const getPaymentByIdentifier = (
  accountId: MaybeRefOrGetter<number>,
  identifier: MaybeRefOrGetter<string>,
  params: MaybeRefOrGetter<GetPaymentByIdentifierParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  identifier = toValue(identifier)
  params = toValue(params)

  return customInstance<Payment>(
    {
      url: `/api/v1/accounts/${accountId}/payments/${identifier}`,
      method: "GET",
      params,
      signal,
    },
    options,
  )
}

export const getGetPaymentByIdentifierQueryKey = (
  accountId: MaybeRefOrGetter<number>,
  identifier: MaybeRefOrGetter<string>,
  params?: MaybeRefOrGetter<GetPaymentByIdentifierParams>,
) => {
  return [
    "api",
    "v1",
    "accounts",
    accountId,
    "payments",
    identifier,
    ...(params ? [params] : []),
  ] as const
}

export const useGetPaymentByIdentifierQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentByIdentifier>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  identifier: MaybeRefOrGetter<string>,
  params: MaybeRefOrGetter<GetPaymentByIdentifierParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentByIdentifier>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetPaymentByIdentifierQueryKey(
    accountId,
    identifier,
    params,
  )

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPaymentByIdentifier>>
  > = ({ signal }) =>
    getPaymentByIdentifier(
      accountId,
      identifier,
      params,
      requestOptions,
      signal,
    )

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () =>
          toValue(accountId) !== null &&
          toValue(accountId) !== undefined &&
          toValue(identifier) !== null &&
          toValue(identifier) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId, identifier, params },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentByIdentifier>>,
    TError,
    TData
  >
}

export type GetPaymentByIdentifierQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentByIdentifier>>
>
export type GetPaymentByIdentifierQueryError = ErrorType<Error>

/**
 * @summary Get a payment by a unique identifier
 */

export function useGetPaymentByIdentifier<
  TData = Awaited<ReturnType<typeof getPaymentByIdentifier>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  identifier: MaybeRefOrGetter<string>,
  params: MaybeRefOrGetter<GetPaymentByIdentifierParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentByIdentifier>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetPaymentByIdentifierQueryOptions(
    accountId,
    identifier,
    params,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Make a card payment
 */
export const makePayment = (
  accountId: MaybeRefOrGetter<number>,
  makePaymentRequest: MaybeRefOrGetter<MakePaymentRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  makePaymentRequest = toValue(makePaymentRequest)

  return customInstance<MakePaymentResponse>(
    {
      url: `/api/v1/accounts/${accountId}/payments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: makePaymentRequest,
      signal,
    },
    options,
  )
}

export const useMakePaymentMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof makePayment>>,
    TError,
    { accountId: number; data: MakePaymentRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof makePayment>>,
  TError,
  { accountId: number; data: MakePaymentRequest },
  TContext
> => {
  const mutationKey = ["makePayment"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof makePayment>>,
    { accountId: number; data: MakePaymentRequest }
  > = (props) => {
    const { accountId, data } = props ?? {}

    return makePayment(accountId, data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type MakePaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof makePayment>>
>
export type MakePaymentMutationBody = MakePaymentRequest
export type MakePaymentMutationError = ErrorType<Error>

/**
 * @summary Make a card payment
 */
export const useMakePayment = <TError = ErrorType<Error>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof makePayment>>,
      TError,
      { accountId: number; data: MakePaymentRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof makePayment>>,
  TError,
  { accountId: number; data: MakePaymentRequest },
  TContext
> => {
  return useMutation(useMakePaymentMutationOptions(options), queryClient)
}
/**
 * @summary Create a flow payment session
 */
export const createPaymentSession = (
  accountId: MaybeRefOrGetter<number>,
  makePaymentRequest: MaybeRefOrGetter<MakePaymentRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  makePaymentRequest = toValue(makePaymentRequest)

  return customInstance<MakePaymentSessionResponse>(
    {
      url: `/api/v2/accounts/${accountId}/payments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: makePaymentRequest,
      signal,
    },
    options,
  )
}

export const useCreatePaymentSessionMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPaymentSession>>,
    TError,
    { accountId: number; data: MakePaymentRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPaymentSession>>,
  TError,
  { accountId: number; data: MakePaymentRequest },
  TContext
> => {
  const mutationKey = ["createPaymentSession"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPaymentSession>>,
    { accountId: number; data: MakePaymentRequest }
  > = (props) => {
    const { accountId, data } = props ?? {}

    return createPaymentSession(accountId, data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type CreatePaymentSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPaymentSession>>
>
export type CreatePaymentSessionMutationBody = MakePaymentRequest
export type CreatePaymentSessionMutationError = ErrorType<Error>

/**
 * @summary Create a flow payment session
 */
export const useCreatePaymentSession = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPaymentSession>>,
      TError,
      { accountId: number; data: MakePaymentRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof createPaymentSession>>,
  TError,
  { accountId: number; data: MakePaymentRequest },
  TContext
> => {
  return useMutation(
    useCreatePaymentSessionMutationOptions(options),
    queryClient,
  )
}
